// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/sparkles.js';

import { paths } from '../generated/sparkles';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('sparkles', Original, paths);
